import {
  getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveLoader,
  getFeeChargeEventBasisBreakdownByUseRetrieveLoader,
  getFeeChargeEventPointInTimeTransactionCodesListLoader,
  getFeeChargeEventRetrieveLoader,
  getFeePeriodHistoricalTrueUpBreakdownRetrieveLoader,
  getFeePeriodOffsetsTrueUpBreakdownRetrieveLoader,
  getFeeTrueUpHistoricalPreviewStatsRetrieveLoader,
} from "gen/endpoints/fee-charge-event/fee-charge-event";
import { FundFamilyEventTypeEnum } from "gen/model/fundFamilyEventTypeEnum";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";
import { composeLoaders } from "shared/utils/RoutingUtils";

export const lateFeeOffsetPostRoutes: RouteObject = {
  id: "lateOffsets",
  path: "late-offsets/:feeChargeEventId/:adjustmentFundFamilyEventId",
  lazy: async () => {
    const { FeePostingLateOffsetsPage } = await import(
      "features/fees/post/apply-offsets/FeePostingLateOffsetsPage"
    );
    return { Component: FeePostingLateOffsetsPage };
  },
  loader: getFeeChargeEventRetrieveLoader(),
  children: [
    {
      id: "lateOffsetsApplyOffsets",
      path: "offsets",
      lazy: async () => {
        const { FeePostLateApplyOffsetsPage } = await import(
          "features/fees/post/apply-offsets/FeePostLateApplyOffsetsPage"
        );
        return { Component: FeePostLateApplyOffsetsPage };
      },
      handle: {
        title: i18n.t("fees:footer.applyOffsets"),
      },
    },
    {
      id: "lateOffsetsReviewFees",
      path: "review",
      lazy: async () => {
        const { FeePostReviewLateOffsetsPage } = await import(
          "features/fees/post/apply-offsets/FeePostReviewLateOffsetsPage"
        );
        return { Component: FeePostReviewLateOffsetsPage };
      },
      handle: {
        title: i18n.t("fees:footer.reviewFees"),
      },
    },
  ],
};

export const feePostRoutes: RouteObject = {
  id: "feesPost",
  path: "post/:feeChargeEventId/*",
  lazy: async () => {
    const { FeePostingPage } = await import(
      "features/fees/post/FeePostingPage"
    );
    return { Component: FeePostingPage };
  },
  loader: composeLoaders(
    getFeeChargeEventRetrieveLoader(),
    getFeeChargeEventPointInTimeTransactionCodesListLoader(),
  ),
  children: [
    {
      id: "feesPostReviewBasis",
      path: "basis/*",
      lazy: async () => {
        const { FeePostReviewBasisPage } = await import(
          "features/fees/post/FeePostReviewBasisPage"
        );
        return { Component: FeePostReviewBasisPage };
      },
      children: [
        {
          id: "feesPostReviewBasisHistoricalTrueUp",
          path: "historical",
          lazy: async () => {
            const { FeePostReviewBasisHistoricalTrueUpTab } = await import(
              "features/fees/post/FeePostReviewBasisHistoricalTrueUpTab"
            );
            return { Component: FeePostReviewBasisHistoricalTrueUpTab };
          },
          loader: composeLoaders(
            getFeeTrueUpHistoricalPreviewStatsRetrieveLoader(),
            getFeePeriodHistoricalTrueUpBreakdownRetrieveLoader(),
            getFeePeriodOffsetsTrueUpBreakdownRetrieveLoader({
              posted_fund_family_event_type: FundFamilyEventTypeEnum.charge_fee,
            }),
          ),
          handle: {
            title: i18n.t("fees:postFees.tabs.historicalBasisTrueUp.title"),
          },
        },
        {
          id: "feesPostReviewBasisBreakdown",
          path: "investor",
          lazy: async () => {
            const { FeePostReviewBasisBreakdownTab } = await import(
              "features/fees/post/FeePostReviewBasisBreakdownTab"
            );
            return { Component: FeePostReviewBasisBreakdownTab };
          },
          loader: composeLoaders(
            getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveLoader({
              is_equalized_view: false,
            }),
            getFeeChargeEventBasisBreakdownByUseRetrieveLoader(),
          ),
          handle: {
            title: i18n.t("fees:postFees.tabs.basisBreakdown"),
          },
        },
      ],
      handle: {
        title: i18n.t("fees:footer.reviewFeeBasis"),
      },
    },
    {
      id: "feesPostApplyOffsets",
      path: "offsets",
      lazy: async () => {
        const { FeePostApplyOffsetsPage } = await import(
          "features/fees/post/apply-offsets/FeePostApplyOffsetsPage"
        );
        return { Component: FeePostApplyOffsetsPage };
      },
      handle: {
        title: i18n.t("fees:footer.applyOffsets"),
      },
    },
    {
      id: "feesPostReviewFees",
      path: "review",
      lazy: async () => {
        const { FeePostReviewPostingPage } = await import(
          "features/fees/post/FeePostReviewPostingPage"
        );
        return { Component: FeePostReviewPostingPage };
      },
      handle: {
        title: i18n.t("fees:footer.reviewFees"),
      },
    },
  ],
};
